import { Navigate, Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePermissions, ResourceType } from '../../hooks/usePermissions';
import { useAuth } from '../../contexts/AuthContext';
export function ProtectedRoute({
  children,
  requiredResourceType,
}: {
  children: React.ReactNode;
  requiredResourceType?: string;
}) {
  const { currentUser, loading } = useAuth();
  const permissions = usePermissions();
  const location = useLocation();
  const { t } = useTranslation('dashboard');
  if (loading || (currentUser && Boolean(requiredResourceType) && permissions.loading))
    return (
      <div className="p-8" role="status">
        {t('loading', { ns: 'common' })}
      </div>
    );
  if (!currentUser || currentUser.isAnonymous)
    return <Navigate to="/login" state={{ from: location }} replace />;
  if (requiredResourceType && !permissions.canRead(requiredResourceType as ResourceType))
    return (
      <div className="p-8 space-y-3" role="alert">
        <p>{t('team.sectionDenied')}</p>
        <Link to="/dashboard" className="underline">
          {t('team.back')}
        </Link>
      </div>
    );
  return <>{children}</>;
}
